import { render, staticRenderFns } from "./LeasesContent.vue?vue&type=template&id=5130c8c8"
import script from "./LeasesContent.vue?vue&type=script&lang=js"
export * from "./LeasesContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports